import React from 'react';
import { PageContent, PageSection, Subtitle, Title } from 'common/styles/page';

const TermsOfService = () => (
  <PageContent>
    <PageSection padright>
      <Title>nuLogic Terms of Service</Title>

      <PageSection padbottom padtop="30px">
        <Subtitle>Terms of Use</Subtitle>
        <p>
          Welcome to nuLogic, the culture optimization software owned by nuwave Equity Corporation,
          a company registered in the United States (a.k.a. ‘we’ or ‘us’ or ‘nuLogic’). We are
          excited to have you as a user of our product and services. The following terms and
          conditions (collectively, these ‘Terms of Service’) apply to your use of nuLogic including
          any applicable free trials, any content, functionality and services offered on or via
          nuLogic (the ‘Service’). We want to keep our relationship with you as lean and informal as
          possible, but please read the Terms of Service carefully before you start using nuLogic,
          because by signing up to the Service and completing your registration you accept and agree
          to be bound and abide by these Terms of Service. Should you disagree with any of the
          provisions herein, you must not use the Service, but please let us know at
          info@nuwaveco.com. We’ll be happy to hear your comments and suggestions.
        </p>
      </PageSection>

      <PageSection padbottom>
        <Subtitle>Changes to the Terms of Service and the Service</Subtitle>
        <p>
          nuwave reserves the right to update the Service and these Terms of Service from time to
          time, at our discretion and without notice. Nevertheless, this document is public on the
          nuwave website (‘Website’), and you will be able to track the changes for any new version.
          Your continued use of the Service following the publishing of updated Terms of Service
          means that you accept and agree to the changes.
        </p>
        <p>
          These Terms of Service were last updated on August 1st, 2024. They are effective between
          you and nuwave as of the date you accepted them (‘Effective Date).
        </p>
      </PageSection>

      <PageSection padbottom>
        <Subtitle>Accessing the Service, Security and Privacy</Subtitle>
        <p>
          We’re working hard on improving nuLogic, but we can’t guarantee that the Service will be
          up and running 24/7. We also reserve the right to suspend or restrict access to some
          features to users, including in the case of system failure, maintenance, repair or reasons
          beyond our control. In any case, we will not be liable if for any reason all or any part
          of the Service is unavailable at any time or for any period.
        </p>
        <p>
          To access the Service you have to register by entering your email address and choosing a
          password as part of our security procedures. You must treat such information as
          confidential, not disclosing it to any third party. There is a password reset procedure in
          case you forget your password, but please notify us of any breach of security. We highly
          recommend to choose a strong password (e.g. ‘itslongWITHCAPSand99numbers!!’) and you log
          out from your account at the end of every session. We will not be responsible for any loss
          or disclosure of your data resulting from your use of the Service, including from your
          failure to adequately secure your login credentials.
        </p>
        <p>
          It is a condition of your use of the Service that all the information you provide on the
          Service is correct, current and complete. In the future, you may be asked to provide
          certain registration details or other information. As is common for online services, we
          reserve the right to disable any user account, at any time in our sole discretion for any
          or no reason, including, if in our opinion you have failed to comply with any provision of
          these Terms of Service.
        </p>
        <p>
          You shall use the Service for your internal business purposes as contemplated by these
          Terms of Service and shall not: (i) tamper with the security of the Service or with the
          accounts of any of our other customers, (ii) log into a server or account that you are not
          authorized to access, (iii) attempt to probe, scan or test the vulnerability of the
          Service or to breach the security or authentication measures without proper authorization;
          (iv) render any part of the Service unusable; (v) lease, distribute, license, sell or
          otherwise commercially exploit the Service or make the Service available to a third party
          other than as contemplated in these Terms of Service; (vi) use the Service for timesharing
          or service bureau purposes or otherwise for the benefit of a third party; or (vii) provide
          to third parties any evaluation or Free Trial (as defined below) version of the Service
          without our prior written consent.
        </p>
        <p>
          In addition, you agree to comply with all applicable laws and regulations in your use of
          the Service and that in particular you will not use the Services to communicate any
          message or material that (i) is libelous, harmful to minors, obscene or constitutes
          pornography; (ii) infringes the intellectual property rights of a third party or is
          otherwise unlawful; or (iii) would otherwise constitute or encourage conduct that could
          constitute a criminal offense under any aplicable law or regulation.
        </p>
        <p>
          We use SSL encrypted browsing for all logged-in users, but we cannot guarantee that all
          use will be secure. We also do not guarantee that the Service or any content provided on
          the Service is error free.
        </p>
        <p>
          We take the protection of your personal data very seriously. For information on how we use
          your personal data please see our Privacy Poliy.
        </p>
      </PageSection>

      <PageSection padbottom>
        <Subtitle>Free Trial</Subtitle>
        <p>
          nuwave may make all or part of the Service available to you on a trial basis free of
          charge (‘Free Trial’). The Free Trial shall begin when you submit a registration to us and
          shall terminate on the earlier of (i) the Free Trial expiration date specified by us upon
          receiving your registration, or (ii) the date you subscribe to a nuLogic Paid Service (as
          defined below). The Service is provided “as-is” and without warranty of any kind during
          the Free Trial. Your data you enter during the Free Trial will be permanently deleted
          within 6 months following the end of the Free Trial. nuwave reserves the right to end or
          extend your free trial at any moment and without warning.
        </p>
      </PageSection>

      <PageSection padbottom>
        <Subtitle>Purchase of the nuLogic Service</Subtitle>
        <p>
          If you agree to pay the fee for access to one of the nuwave subscriptions (nuLogic Paid
          Service’), the applicable non refundable fee will be charged by nuwave to the company or
          other corporate entity designated by you in accordance with the payment method you have
          chosen for your purchase, either as a one off annual payment or on a monthly basis,
          depending on your chosen subscription. If you are paying by credit card, by designating a
          card to be billed, you confirm that you are authorized to make such purchase and that you
          are the holder of such card (i.e. that the card is issued in your name). All prices stated
          on the Website are exclusive of any applicable sales taxes and fees. nuwave accepts a
          variety of different payment methods, so please check the Website for the best way for you
          to pay.
        </p>
        <p>
          By agreeing to pay for an nuLogic Paid Service, you will be charged on the basis of your
          monthly user activity. nuLogic defines an active user as an account that is active as
          controlled by the team management section of the website. Any member can be deactivated
          for any length of time, and/or removed from the organization. Any changes to the active
          status of a user will be reflected in the next month’s billing cyce.
        </p>
        <p>
          We will make the Service available to you during the term of your subscription to the
          nuLogic Paid Service. You agree that your purchase of the nuLogic Paid Service is neither
          contingent upon the delivery of any future functionality or features nor dependent upon
          any oral or written public comments made by us with respect to future functionality or
          features.
        </p>
        <p>
          If you subscribe to nuLogic Paid Service, you may give additional users access to the
          Service up to the number of permitted users specified in the applicable nuLogic Paid
          Service (‘Users’). The Users may include you and your employees, consultants, contractors
          and agents. You must ensure that all Users comply with these Terms of Service and you are
          responsible for such compliance. If you exceed the number of Users permitted by your
          nuLogic Paid Service, you will be in breach of these Terms of Service and we will have the
          right to terminate or suspend your access to the Service or pursue any other remedy
          available to us.
        </p>
      </PageSection>
      <PageSection padbottom>
        <Subtitle>Prices</Subtitle>
        <p>
          nuwave may change the price for the nuLogic Paid Service from time to time. In respect of
          the nuLogic Paid Service, such changed price will take effect after the expiry of the then
          current paid for period (i.e. the term that you have already paid for). Any price change
          will be communicated to you at least 14 days in advance so that you have an opportunity to
          elect to not renew. If you do not wish to be bound by such changed price relating to your
          nuLogic Paid Service you may terminate your subscription of your nuLogic Paid Service in
          accordance with the Section of these Terms of Service entitled “Term and termination”
          below. Your continued use of the nuLogic Paid Service after the communication of such
          price change to you constitutes an acceptance of such new price.
        </p>
      </PageSection>

      <PageSection padbottom>
        <Subtitle>Automatic subscription renewal</Subtitle>
        <p>
          Your subscription to the nuLogic Paid Service will automatically renew at the end of each
          subscription term unless you terminate your subscription prior to the end of such
          subscription term in accordance with the Section entitled “Term and termination”. At the
          time of renewal the payment method you have designated to be charged for the purchase of
          the nuLogic Paid Service will automatically be charged our then current fees for the
          applicable subscriptin.
        </p>
      </PageSection>
    </PageSection>
    <PageSection padbottom>
      <Subtitle>Disclaimer of Warranties, Limitations of Liability and Indemnification</Subtitle>
      <p>
        Your use of the Service is at your sole risk. The Service is provided ‘as is’ and ‘as
        available’. We disclaim all warranties of any kind, express or implied, including, without
        limitation, the warranties of merchantability, fitness for a particular purpose and
        non-infringement. To the maximum extent permitted by law, we are not liable for damages,
        direct or consequential, resulting from your use of the Service, and you agree to defend,
        indemnify and hold us harmless from any claims, losses, liability costs and expenses
        (including but not limited to attorney’s fees) arising from your violation of any
        third-party’s rights to the extent that such violation arises from your use of the Service
        Because the Service is not error or bug free, you agree that you will use it carefully and
        avoid using it in ways which might result in any loss of your or any third party’s property
        or information.
      </p>
      <p>
        Nothing in this agreement shall exclude either party’s liability for death or personal
        injury caused by its negligence or for fraud or fraudulent misrepresentatio.
      </p>
    </PageSection>
    <PageSection padbottom>
      <Subtitle>Third Party Websites and Providers</Subtitle>
      <p>
        Our Service may contain links to third party websites, products or services that are not
        owned or controlled by us. We have no control over, and assume no responsibility for the
        content, privacy policies, or practices of any third party website or service.
      </p>
      <p>
        If you use our Service in conjunction with the applications or services of third parties,
        your use of such applications or services is subject to the terms and conditions specified
        by those third parties and we assume no responsibility for your use of the same.
      </p>
    </PageSection>
    <PageSection padbottom>
      <Subtitle>Term and Termination</Subtitle>
      <p>
        These Terms of Service will become effective on the Effective Date and will remain effective
        until terminated by you or nuwave. You may cancel your subscription of the nuLogic Paid
        Service at any time by visiting your subscription page, which termination shall have effect
        at the expiry of the then-current subscription period that you have already paid for (e.g.
        one month, one quarter or a year). nuwave will not refund any remaining portion of
        subscription fees you have already paid for. nuwave reserves the right to terminate these
        Terms of Service or suspend your nuLogic account at any time in case of unauthorized, or
        suspected unauthorized use of the Service whether in contravention of this Agreement or
        otherwise. If nuwave terminates these Terms of Service, or suspends your nuLogic account for
        any of the reasons set out in this section, then to the maximum extent permitted by law,
        nuwave shall have no liability or responsibility to you, and will not refund any amounts
        that you have previously paid.
      </p>
    </PageSection>
    <PageSection padbottom>
      <Subtitle>Confidentiality</Subtitle>
      <p>
        You and nuwave each agree to keep confidential all confidential information provided to it
        by the other party in connection with these Terms of Service and to protect such
        confidential information in the same manner as it protects its own confidential information.
        Neither of you nor nuwave will disclose or use any confidential information of the other
        party for any purpose outside the scope of these Terms of Service except with the disclosing
        party’s consent or as required by law.
      </p>
    </PageSection>
    <PageSection padbottom>
      <Subtitle>Customer Data</Subtitle>
      <p>
        You retain all right, title and interest in and to all data (including personal data) that
        you upload to nuLogic or otherwise provide to nuwave through your use of the Service.
      </p>
    </PageSection>
    <PageSection padbottom>
      <Subtitle>Intellectual property</Subtitle>
      <p>
        If you are accessing this Website or the Services from the European Union, Asia, or any
        other region with laws or regulations governing personal data collection, use, and
        disclosure that differ from United States laws, please be advised that through your
        continued use of the Website and Services, which are governed by U.S. law and this Privacy
        Policy as incorporated into our Terms of Service, you will be transferring your personal
        information into the United States and you consent to that transfr.
      </p>
      <p>
        If you are a copyright holder who believes that any of the products, services or content
        which are directly available via the Service are infringing copies of your work, please let
        us know. Pursuant to The Digital Millennium Copyright Act, 17 United States Code 512(c)(3),
        a notice of alleged copyright infringement should be sent to nuwave’s designated copyright
        agent at the following address:  info@nuwaveco.com.
      </p>
      <p>
        A notification of claimed copyright infringement must be addressed to nuwave’s copyright
        agent listed above and include the following: A physical or electronic signature of the
        owner (or person authorized to act on behalf of the owner) of the copyright that is
        allegedly infringed; Specific identification of each copyrighted work claimed to have been
        infringed; A description of where the material believed to be infrined is located on the
        Service (please be as detailed as possible and provide a URL to help us locate the material
        you are reporting); Contact information for the complaining party, such as a complete name,
        address, telephone number, and email address; A statement that the complaining party has a
        good faith belief that use of the work(s) in the manner complained of is not authorized by
        the copyright owner, its agent, or the law; and A statement that the information in the
        notification is accurate, and under penalty of perjury, that the complaining party is
        authorized to act on behalf of the owner of an exclusive right that is allegedly infringed.
      </p>
    </PageSection>
    <PageSection padbottom>
      <Subtitle>Technology Limitations and Modifications</Subtitle>
      <p>
        nuwave will make reasonable efforts to keep the Service operational. However, certain
        technical difficulties or maintenance may, from time to time, result in temporary
        interruptions. nuwave reserves the right at any time and from time to time to modify or
        discontinue, temporarily or permanently, functions and features of the Service with or
        without notice.
      </p>
    </PageSection>
    <PageSection padbottom>
      <Subtitle>Assignment</Subtitle>
      <p>
        nuwave may assign this Agreement or any part of it without restrictions. You may not assign
        this Agreement or any part of it to any third party.
      </p>
    </PageSection>
    <PageSection padbottom>
      <Subtitle>Entire Agreement</Subtitle>
      <p>
        These Terms of Service constitute all the terms and conditions agreed upon between you and
        nuwave and supersede any prior agreements in relation to the subject matter of these Terms
        of Service, whether written or oral. Any additional or different terms or conditions in
        relation to the subject matter of these Terms of Service in any written or oral
        communication from you to nuwave are void. You agree and accept that you have not accepted
        the terms and conditions of these Terms of Service in reliance of or to any oral or written
        representations made by nuwave not contained in this Agreement.
      </p>
    </PageSection>
    <PageSection padbottom>
      <Subtitle>Severability</Subtitle>
      <p>
        Should for any reason or to any extent any provision of these Terms of Service be held
        invalid or unenforceable, such invalidity or enforceability shall not in any manner affect
        or render invalid or unenforceable the remaining provisions of these Terms of Service and
        the application of that provision shall be enforced to the extent permitted by law.
      </p>
    </PageSection>
    <PageSection padbottom>
      <Subtitle>Independent Contractors</Subtitle>
      <p>
        You and nuwave are independent contractors. These Terms of Service do not create a joint
        venture or partnership between you and nuwave and neither of us are by virtue of these Terms
        of Service authorized to act as an agent, employee or representative of the other party.
      </p>
    </PageSection>
    <PageSection padbottom>
      <Subtitle>Amendment and Waiver</Subtitle>
      <p>
        nuwave may revise these Terms of Service from time to time. Any waiver of any right or
        remedy under these Terms of Service by nuwave must be in writing and signed by us. No delay
        in exercising any right or remedy shall operate as a waiver of such right or remedy or any
        other right or remedy. A waiver on one occasion shall not be construed as a waiver of any
        right or remedy on any future occasion.
      </p>
    </PageSection>
    <PageSection padbottom>
      <Subtitle>Notices</Subtitle>
      <p>
        Any notices under these Terms of Service shall be in writing and shall be deemed to have
        been delivered: (i) upon personal delivery; (ii) the fifth business day after mailing; or
        (iii) the third business day after sending by email. Notices to nuwave shall be addressed as
        follows:
      </p>
      <p>info@nuwaveco.com</p>
    </PageSection>

    <PageSection padbottom>
      <Subtitle>
        Mandatory arbitration; exceptions to mandatory arbitration, waiver of class action rights;
        limitations period; venue and choice of law
      </Subtitle>
      <p>
        i. You and nuwave agree that any dispute, claim or controversy arising out of or relating in
        any way to the Service or your use thereof, including our Agreement, shall be determined by
        mandatory binding arbitration. You agree that the State of Vermont, USA governs the
        interpretation and enforcement of this provision, and that you and nuwave are each waiving
        the right to a trial by jury and the right to participate in a class or multi-party action.
        This arbitration provision shall survive termination of these Terms of Service and the
        termination of your subscription to an nuLogic Paid Service.
      </p>
      <p>
        ii. You and nuwave agree that (a) any claims seeking to enforce, protect, or determine the
        validity or ownership of any intellectual property rights, and (b) any claims related to
        allegations of theft, piracy or unauthorized use of the Service are NOT subject to mandatory
        arbitration. Instead, you and nuwave agree that the preceding claims (including but not
        limited to claims for injunctive or equitable relief) shall be exclusively decided by Courts
        of competent jurisdiction in the State of Vermont, USA and/or United States federal law
        shall govern, without regarding to choice of law principals. iii. YOU AND NUWAVE AGREE THAT
        EACH MAY BRING CLAIMS AGAINST THE OTHER ONLY IN YOUR OR ITS INDIVIDUAL CAPACITY, AND NOT AS
        A CLASS MEMBER OR IN ANY REPRESENTATIVE CAPACITY OR PROCEEDING. Further, the arbitrator
        shall not consolidate any other person’s claims with your claims, and may not otherwise
        preside over any form of a multi-party or class proceeding. If this specific provision is
        found to be unenforceable in any way, then the entirety of this arbitration section shall be
        null and void. The arbitrator may not award declaratory or injunctive relief. iv. Any
        arbitration must be commenced by filing a demand for arbitration within ONE (1) YEAR after
        the date the party asserting the claim first knows or reasonably should know of the act,
        omission or default giving rise to the claim; and there shall be no right to any remedy for
        any claim not asserted within that time period. If applicable law prohibits a one-year
        limitations period for asserting claims, any claim must be asserted within the shortest time
        period permitted by applicable law. Your arbitration fees and your share of arbitrator
        compensation will be limited to those fees set forth in the applicable arbitration rules
        with the remainder paid by nuwave . Any arbitration costs or fees deemed ‘excessive’ will be
        paid by nuwave. v. You and nuwave further agree that applicable laws of Vermont shall
        exclusively govern any dispute without regard to choice or conflicts of law rules. The sole
        and exclusive venue for the resolution of any dispute, whether or not subject to mandatory
        arbitration as described above, shall lie in Vermont.
      </p>
    </PageSection>
    <PageSection padbottom>
      <Subtitle>English Version Prevails</Subtitle>
      <p>
        In the event that these Terms of Service are translated into other languages and there is a
        discrepancy between the two language versions, the English language version shall prevail to
        the extent that such discrepancy is the result of an error in translation. Copyright ©{' '}
        {new Date().getFullYear()} nuwave and its affiliates. All rights reserved.
      </p>
    </PageSection>
  </PageContent>
);

export default TermsOfService;
